"use client";

import Link from "next/link";
import { trackFunnel } from "@/libs/analytics";
import { GO_VIRAL_AVATARS_HREF, GO_VIRAL_CATEGORY_ID } from "@/app/editor/data/ai-photo-editor";
import type { DashboardViralAvatarStyle } from "@/components/dashboard/jtbd/jtbdData";

export default function CatalogAvatarStyleCard({ style }: { style: DashboardViralAvatarStyle }) {
  const href = `${GO_VIRAL_AVATARS_HREF}?style=${encodeURIComponent(style.id)}`;

  return (
    <Link
      href={href}
      onClick={() =>
        trackFunnel("tool_engagement", "dashboard_card_clicked", {
          tool_id: "ai-avatars",
          card_type: "style",
          card_id: String(style.id),
          section: GO_VIRAL_CATEGORY_ID,
          destination_href: href,
        })
      }
      className="group block"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden rounded-2xl bg-gray-100">
        <img
          src={style.image}
          alt={style.title}
          className="absolute inset-0 h-full w-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
          loading="lazy"
        />
      </div>
      <div className="pt-3">
        <h3 className="text-base font-bold text-gray-900 leading-tight">{style.title}</h3>
      </div>
    </Link>
  );
}
